import { FC } from 'react'
import { PrimaryTags as View } from 'ui-components'
import {
  TGetCategoryTagsResults,
  useGetCategoryTags
} from '~explore/queries/useGetCategoryTags'
import { Category_Tag_Type } from '~explore/types/__generated/gql/graphql'

const PrimaryTags: FC<{ initialData: TGetCategoryTagsResults }> = ({
  initialData
}) => {
  const { data = [], isLoading } = useGetCategoryTags(
    {
      categoryTypes: [Category_Tag_Type.Primary],
      size: 3
    },
    true,
    initialData
  )

  return (
    <View
      isLoading={isLoading}
      tags={data}
      getKey={(tag) => tag.id}
      getHref={(tag) => `/search?sort=all&tags=${tag.id}`}
      getCover={(tag) =>
        `https://${process.env.TAG_ASSETS_URL}/${tag.thumbnail}?${tag.updatedAt}`
      }
      getTitle={(tag) => tag.name}
    />
  )
}

export { PrimaryTags }
